export default function ComplianceCard({ abbr, title, description, icon: Icon }) {
  return (
    <article className="mk-compliance-card">
      <div className="mk-compliance-card-icon" aria-hidden="true">
        {Icon ? <Icon size={22} strokeWidth={1.9} /> : null}
      </div>
      <div className="mk-compliance-card-abbr">{abbr}</div>
      <h3 className="mk-compliance-card-title">{title}</h3>
      {description ? <p className="mk-compliance-card-desc">{description}</p> : null}
    </article>
  );
}
